// extracted by mini-css-extract-plugin
module.exports = {"dot":"style-module--dot--2skm_","active":"style-module--active--3hPnl","next":"style-module--next--7ywe9","dots_wraper":"style-module--dots_wraper--1Y6NM"};